var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('single-select',{attrs:{"value":_vm.usedPreset,"options":_vm.presets,"getOptionLabel":_vm.localizeOption,"placeholder":_vm.$t('presetbar.label_placeholder')},on:{"input":_vm.onPresetSelected}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f87185e8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/presetbar/DaterangePresets.vue
// module id = 681
// module chunks = 1